//--- React Libraries
import React, { useState, useEffect } from "react";
//--- Design Libraries
import { Card, Tooltip } from "antd";
import { TableOutlined, CloseCircleOutlined } from '@ant-design/icons';
//---Project 
import TimeSeriesChart from "components/Common/Charts/TimeSeriesChart";
// import BoxPlotRawData from "components/Common/Charts/BoxPlot";
import BoxPlotRawData from "components/Common/Charts/HCBoxPlot";
// import HistogramChart from "components/Common/Charts/HistogramChart";
import ScatterChart from "components/Common/Charts/ScatterChart";
import HistogramChart from "components/Common/Charts/HCHistogram";
import ChangeIcon from "components/Common/CustomIcons/Change";
import { CHART_TYPE } from "./dbConstants";
import Loading from "components/Common/Loading";
import APIError from "components/Common/APIError";
import NoData from "components/Common/NoData";
import DataGrid from "./DataGrid";

const GraphPanel = React.memo(({title, plotType, plotColor, panelSeries, 
  panelData, panelUnits='', showLive=false, showCloseButton=false, isLoading=true,
  isError=false, dataErrorMsg='Unexpected Error',
  enableZoom, syncZoom, 
  crossHair, onCursorLeave, onCursorMove, 
  setChartRef, setContainerRef,
  chartIndex
}) => {
  const chart_types = Object.values(CHART_TYPE);
  const [showDataModal, setShowDataModal] = useState(false);
  const [viewIndex, setViewIndex] = useState(0);

  const onClickDataIcon = () => {
    setShowDataModal(true);
  }

  const onCloseModal = () => {
    setShowDataModal(false);
  }

  const onClickCurrentView = () => {
    if (viewIndex >= chart_types.length-1){
      setViewIndex(0);
    } else {
      setViewIndex((p) => p+1);
    }
  }

  useEffect (() =>{
    setViewIndex(Object.values(CHART_TYPE).indexOf(plotType));
  }, [plotType])

  const renderChart = () => {
    switch(chart_types?.[viewIndex]){
    // switch(plotType){
      case CHART_TYPE.TIMESERIES:
        return <TimeSeriesChart
            seriesColor={plotColor}
            seriesName={panelSeries}
            yAxisUnits={panelUnits}
            data={panelData}
            zoomType={enableZoom ? 'x' : undefined}
            enableSync={enableZoom}
            syncZoom={syncZoom}
            crossHair={crossHair}
            onMouseMove={onCursorMove}
            onMouseLeave={onCursorLeave}
            setChartRef={setChartRef}
            setContainerRef={setContainerRef}
            chartIndex={chartIndex}
            chartKey={`ts-${panelSeries?.slice(-4)}-${chartIndex}`}
          />;
      case CHART_TYPE.SCATTER:
        return <ScatterChart
            seriesColor={plotColor}
            seriesName={panelSeries}
            yAxisUnits={panelUnits}
            data={panelData}
            zoomType={enableZoom ? 'x' : undefined}
            enableSync={true}
            syncZoom={syncZoom}
            crossHair={crossHair}
            onMouseMove={onCursorMove}
            onMouseLeave={onCursorLeave}
            setChartRef={setChartRef}
            setContainerRef={setContainerRef}
            chartIndex={chartIndex}
            chartKey={`sc-${panelSeries?.slice(-4)}-${chartIndex}`}
          />;
      case CHART_TYPE.BOXPLOT:
        return <BoxPlotRawData
            data={panelData?.map((value) => value?.[1])}
            seriesName={panelSeries}
            chartKey={`bp-${panelSeries?.slice(-4)}-${chartIndex}`}
          />;
      case CHART_TYPE.HISTOGRAM:
        return <HistogramChart
            data={panelData?.map((value) => value?.[1])}
            seriesName={panelSeries}
            chartKey={`hc-${panelSeries?.slice(-4)}-${chartIndex}`}
          />;
      default:
        return <Loading/>;
    }
  }
  
  return(
    <>
      {showDataModal && <DataGrid
          dataModalOpen={showDataModal}
          gridData={panelData}
          gridField={[panelSeries]}
          onCloseModal={onCloseModal}
        />
      }
      <Card title={title} bordered={false} style={{minHeight:'330px'}}
        extra={
          <div>
            <Tooltip title={'Switch Graph'}>
              <ChangeIcon onClick={onClickCurrentView}/>
            </Tooltip>
            <span style={{marginLeft: '20px'}}></span>
            <Tooltip title={"View Data"}>
              <TableOutlined onClick={onClickDataIcon} style={{fontSize: '18px'}}/>
            </Tooltip>
            <span style={{marginLeft: '20px'}}></span>
            {showCloseButton && 
              <Tooltip title={'Close'}>
                <CloseCircleOutlined />
              </Tooltip>
            }
          </div>
        }
      >
        <div style={{ overflow: 'auto'}}>
          {isLoading ?
            <Loading/>
            :
            isError ?
              <APIError message={dataErrorMsg}/>
              :
              panelData?.length ? 
                renderChart() : <NoData/>
          }
        </div>
      </Card>
    </>
  )
})

export default GraphPanel;